import { ClipboardList } from "lucide-react";
import type { DriverStop } from "../lib/normalize";

export function SummaryStrip({
  stops,
  onOpenDailyReport,
  canCreateReport,
}: {
  stops: DriverStop[];
  onOpenDailyReport: () => void;
  /** 当日に出勤打刻済みか。日報は出勤した日のみ作成できる (退勤後も clock_in_at は残るため作成可)。 */
  canCreateReport: boolean;
}) {
  const delivered = stops.filter((s) => s.kind === "delivery");
  const collected = stops.filter((s) => s.kind === "collect");
  const deliveredDone = delivered.filter((s) => s.status === "done").length;
  const collectedDone = collected.filter((s) => s.status === "done").length;
  const kpis = [
    { l: "配達", v: `${deliveredDone}/${delivered.length}`, u: "完" },
    { l: "回収", v: `${collectedDone}/${collected.length}`, u: "件" },
    { l: "停車", v: String(stops.length), u: "件" },
    // 残 = 未着/対応中のみ。完了・キャンセル (終了状態) は残件に数えない
    {
      l: "残",
      v: String(stops.filter((s) => s.status !== "done" && s.status !== "cancelled").length),
      u: "",
    },
  ];
  return (
    <div className="mx-2.5 mt-2.5 rounded-lg bg-[var(--bg-raised)] px-3.5 py-3 shadow-sm">
      <div className="mb-2 flex items-center justify-between">
        <div className="text-[length:var(--fs-sm)] font-semibold">本日の運行</div>
      </div>
      <div className="grid grid-cols-4 gap-1.5 text-[length:var(--fs-xs)]">
        {kpis.map((x) => (
          <div
            key={x.l}
            role={x.l === "配達" ? "group" : undefined}
            aria-label={x.l === "配達" ? `配達進捗 ${x.v}` : undefined}
            className="rounded-md bg-[var(--bg-sunken)] px-1.5 py-1.5"
          >
            <div className="text-[length:var(--fs-xs)] text-[var(--ink-3)]">{x.l}</div>
            <div className="text-[length:var(--fs-xs)] font-semibold">
              {x.v}{" "}
              <span className="text-[length:var(--fs-xs)] font-normal text-[var(--ink-3)]">
                {x.u}
              </span>
            </div>
          </div>
        ))}
      </div>
      {/* 日報は出勤した日のみ作成可。未出勤時はボタンを出さずヒントを表示する。 */}
      {canCreateReport ? (
        <button
          type="button"
          onClick={onOpenDailyReport}
          className="mt-2.5 flex w-full cursor-pointer items-center justify-between rounded-lg border border-[var(--rule-soft)] bg-[var(--bg-sunken)] px-3 py-2.5 text-[length:var(--fs-sm)] font-medium text-[var(--ink)]"
        >
          <span className="flex items-center gap-1.5">
            <ClipboardList size={16} /> 今日の運転日報を作成
          </span>
          <span className="text-[var(--ink-3)]">›</span>
        </button>
      ) : (
        <p className="mt-2.5 rounded-lg bg-[var(--bg-sunken)] px-3 py-2.5 text-[length:var(--fs-xs)] text-[var(--ink-3)]">
          出勤打刻すると今日の運転日報を作成できます
        </p>
      )}
    </div>
  );
}
